import { template as template_86a7804f44fd4dc1bc89a2634a8b15d7 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import styles from './panel-loading-state.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
export default class RequestClinicianSearchFiltersPanelLoadingState extends Component {
    styles = styles;
    static{
        template_86a7804f44fd4dc1bc89a2634a8b15d7(`
    <div class={{this.styles.loadingState}} role="status" aria-live="polite" ...attributes>
      {{svgJar "circle-notch" class="icon-spinner" aria-label=@ariaLabel}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
